import { render } from "./CreateOtherWork.vue?vue&type=template&id=5c87d592"
import script from "./CreateOtherWork.vue?vue&type=script&lang=js"
export * from "./CreateOtherWork.vue?vue&type=script&lang=js"

import "./CreateOtherWork.vue?vue&type=style&index=0&id=5c87d592&lang=css"

import exportComponent from "E:\\Sources\\Repos\\TaskApi\\TaskApp.VueCore\\clientTaskApp\\clientTaskApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__